import { preprocess } from '@artica/assets';
import {
  BufferGeometry,
  BufferAttribute,
  PointsMaterial,
} from 'three';

const generateParticlePositions = particleCount => {
  const arr = new Float32Array(particleCount * 3);
  for (let i = 0; i < particleCount; i++) {
    arr[i] = (Math.random() - 0.5) * 3000;
  }
  return arr;
};

preprocess('star1', function preprocessStar1(texture) {
  const geometry = new BufferGeometry();
  geometry.setAttribute(
    'position',
    new BufferAttribute(generateParticlePositions(350), 3)
  );

  const material = new PointsMaterial({
    size: 15,
    map: texture,
    transparent: true,
    opacity: 0,

    fog: false,
    toneMapped: false,
    alphaTest: false,
    depthWrite: false,
  });
  
  const position = [-100, -350, -2200];

  return {
    texture,
    material,
    geometry,
    position,
  };
});

preprocess('star2', function preprocessStar1(texture) {
  const geometry = new BufferGeometry();
  geometry.setAttribute(
    'position',
    new BufferAttribute(generateParticlePositions(1500), 3)
  );

  const material = new PointsMaterial({
    size: 20,
    map: texture,
    transparent: true,
    opacity: 0,

    fog: false,
    toneMapped: false,
    alphaTest: false,
    depthWrite: false,
  });
  
  const position = [0, 0, 0];

  return {
    texture,
    material,
    geometry,
    position,
  };
});